import { FeaturesConfig } from "../types";
import { featuresCommon } from "./featuresCommon";

export const featuresProd: FeaturesConfig = {
  ...featuresCommon,
};
